const ITEMS = {
    SWORD_001: {
        ID: 'SWORD_001',
        name: 'gladius',
        type: 'sword',
        icon: '🗡',
        range: 10,
        rate: 20,
        slots: 1,
        slot: 'hand',
        damage: [
            {
                category: 'physical',
                element: 'slashing',
                tier: {
                    1: 10,
                    2: 12,
                    3: 15,
                    4: 19,
                    5: 24,
                },
            },
        ],
    },
    SWORD_011: {
        ID: '011',
        name: 'flame blade',
        type: 'sword',
        icon: '🗡🔥',
        range: 10,
        rate: 20,
        slots: 1,
        slot: 'hand',
        damage: [
            {
                category: 'physical',
                element: 'slashing',
                tier: {
                    1: 8,
                    2: 10,
                    3: 13,
                    4: 17,
                    5: 22,
                },
            },
            {
                category: 'magical',
                element: 'fire',
                tier: {
                    1: 4,
                    2: 6,
                    3: 9,
                    4: 13,
                    5: 18,
                },
            },
        ],
        stats: {
            rate: -10,
        },
    },
    MACE_001: {
        ID: 'MACE_001',
        name: 'hammer',
        type: 'mace',
        icon: '🔨',
        range: 15,
        rate: 25,
        slots: 1,
        slot: 'hand',
        damage: [
            {
                category: 'physical',
                element: 'blunt',
                tier: {
                    1: 12,
                    2: 14,
                    3: 17,
                    4: 21,
                    5: 26,
                },
            },
        ],
    },
    DAGGER_001: {
        ID: 'DAGGER_001',
        name: 'kitchen knife',
        type: 'dagger',
        icon: '🔪',
        range: 10,
        rate: 10,
        slots: 1,
        slot: 'hand',
        damage: [
            {
                category: 'physical',
                element: 'piercing',
                tier: {
                    1: 7,
                    2: 9,
                    3: 12,
                    4: 16,
                    5: 21,
                },
            },
        ],
    },
    BOW_001: {
        ID: 'BOW_001',
        name: 'wooden bow',
        type: 'bow',
        icon: '🏹',
        range: 100,
        rate: 35,
        slots: 2,
        slot: 'twohanded',
        damage: [
            {
                category: 'physical',
                element: 'piercing',
                tier: {
                    1: 18,
                    2: 21,
                    3: 25,
                    4: 30,
                    5: 36,
                },
            },
        ],
    },
    SHIELD_001: {
        ID: 'SHIELD_001',
        name: 'simple shield',
        type: 'shield',
        icon: '🛡',
        range: 10,
        rate: 15,
        slots: 1,
        slot: 'offhand',
        protection: [
            {
                category: 'physical',
                element: 'all',
                tier: {
                    1: 10,
                    2: 13,
                    3: 16,
                    4: 19,
                    5: 22,
                },
            },
        ],
    },
    SHIELD_011: {
        ID: 'SHIELD_011',
        name: 'earth shield',
        type: 'shield',
        icon: '🛡🥔',
        range: 10,
        rate: 25,
        slots: 1,
        slot: 'offhand',
        protection: [
            {
                category: 'physical',
                element: 'all',
                tier: {
                    1: 15,
                    2: 18,
                    3: 21,
                    4: 24,
                    5: 27,
                },
            },
            {
                category: 'magical',
                element: 'earth',
                tier: {
                    1: 4,
                    2: 6,
                    3: 9,
                    4: 13,
                    5: 18,
                },
            },
        ],
        stats: {
            hp: 25,
        },
    },
    TORSO_001: {
        ID: 'TORSO_001',
        name: 'protective shirt',
        type: 'heavy armor chest',
        slot: 'torso',
        icon: '👕',
        protection: [
            {
                category: 'physical',
                element: 'all',
                tier: {
                    1: 20,
                    2: 23,
                    3: 26,
                    4: 29,
                    5: 32,
                },
            },
        ],
    },
    TROUSERS_001: {
        ID: 'TROUSERS_001',
        name: 'protective pants',
        type: 'heavy armor legs',
        slot: 'legs',
        icon: '👖',
        protection: [
            {
                category: 'physical',
                element: 'all',
                tier: {
                    1: 14,
                    2: 17,
                    3: 20,
                    4: 23,
                    5: 26,
                },
            },
        ],
    },
    BOOTS_001: {
        ID: 'BOOTS_001',
        name: 'protective boots',
        type: 'heavy armor feet',
        slot: 'feet',
        icon: '👞',
        protection: [
            {
                category: 'physical',
                element: 'all',
                tier: {
                    1: 14,
                    2: 17,
                    3: 20,
                    4: 23,
                    5: 26,
                },
            },
        ],
    },
    GLOVES_001: {
        ID: 'GLOVES_001',
        name: 'protective gauntlets',
        type: 'heavy armor hands',
        slot: 'hands',
        icon: '🧤',
        protection: [
            {
                category: 'physical',
                element: 'all',
                tier: {
                    1: 14,
                    2: 17,
                    3: 20,
                    4: 23,
                    5: 26,
                },
            },
        ],
    },
    HELMET_001: {
        ID: 'HELMET_001',
        name: 'protective Helmet',
        type: 'heavy armor helmet',
        slot: 'head',
        icon: '⛑',
        protection: [
            {
                category: 'physical',
                element: 'all',
                tier: {
                    1: 14,
                    2: 17,
                    3: 20,
                    4: 23,
                    5: 26,
                },
            },
        ],
    },
}

export default ITEMS
